import styled from 'styled-components';

export const CustomTag = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: var(--clr-general-hover);
  border: 1px solid var(--clr-general-border-hover);
  padding: 2px 4px 2px 8px;
  border-radius: 50px;
  gap: 8px;
  &.person-tag {
    padding: 4px 15px;
    gap: 5px;
    border: 1px solid var(--clr-border-grey-100);
    background: var(--clr-body-bg);
    .tag-text {
      font-size: 13px;
      font-weight: 400;
    }
    .tag-close-btn {
      width: 14px;
      height: 14px;
      &:not(:disabled):not(.ant-btn-disabled):hover {
        color: var(--clr-general-description);
      }
      .ant-btn-icon {
        font-size: 14px;
        color: var(--clr-general-description);
      }
    }
  }

  .tag-text {
    white-space: nowrap;
    color: var(--clr-title);
    font-size: 11px;
    font-weight: 500;
    line-height: 17px;
  }

  .tag-close-btn {
    border: none !important;
    background-color: transparent !important;
    width: 18px;
    height: 18px;
    &:not(:disabled):not(.ant-btn-disabled):hover {
      color: var(--clr-title);
    }
  }

  .tag-close-btn {
    .ant-btn-icon {
      font-size: 10px;
      color: var(--clr-general-description);
    }
  }
`;
